import React from 'react'
import './Modern.css'
import moderbg from "../../../../assets/images/modern/bg.webp"
import { Link } from 'react-router-dom'

const Modern = () => {
  return (
    <section className="modern">

      <img src={moderbg} alt="" className="modern-bg" />

      <div className="modern-overlay"></div>

      <div className="modern-container">
        <div className="modern-content">

          <h2>
            A Modern Pharmaceutical <br />
            Manufacturing Complex
          </h2>

          <p>
            Advanced Pharmaceutical Industries (API) manufacturing complex
            is designed to meet modern pharmaceutical production requirements
            and international regulatory expectations.
          </p>

          <Link to="/manufacture" className="modern-btn">Learn more</Link>

        </div>
      </div>

    </section>
  )
}

export default Modern